let lastScrollTop = 0;
const header = document.querySelector('body > header');

window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop <= 50) {
        header.classList.remove('scroll-up');
        header.style.position = '';
        header.style.top = '';
    } else if (scrollTop > lastScrollTop) {
        header.style.position = 'relative';
        header.style.top = 'unset';
        header.classList.remove('scroll-up');
    } else {
        header.style.position = '';
        header.style.top = '';
        header.classList.add('scroll-up');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});
/*********************************/




  // function initAllScrollCarousels() {
  //   const carousels = document.querySelectorAll('scroll-carousel.scroll-area');

  //   carousels.forEach((carousel) => {
  //     if (carousel.dataset.autoscrollInitialized === "true") return; // Prevent multiple inits
  //     carousel.dataset.autoscrollInitialized = "true";

  //     const scrollAmount = carousel.clientWidth;
  //     const scrollDelay = 4000;

  //     let interval = setInterval(() => {
  //       const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;

  //       if (carousel.scrollLeft + scrollAmount >= maxScrollLeft) {
  //         carousel.scrollTo({ left: 0, behavior: 'smooth' });
  //       } else {
  //         carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  //       }
  //     }, scrollDelay);

  //     // Optional: Pause on hover
  //     carousel.addEventListener('mouseenter', () => clearInterval(interval));
  //     carousel.addEventListener('mouseleave', () => {
  //       interval = setInterval(() => {
  //         const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;

  //         if (carousel.scrollLeft + scrollAmount >= maxScrollLeft) {
  //           carousel.scrollTo({ left: 0, behavior: 'smooth' });
  //         } else {
  //           carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  //         }
  //       }, scrollDelay);
  //     });
  //   });
  // }

  // // Run on page load
  // document.addEventListener('DOMContentLoaded', initAllScrollCarousels);

  // // Observe dynamically added sliders
  // const observer = new MutationObserver(() => {
  //   initAllScrollCarousels();
  // });

  // observer.observe(document.body, { childList: true, subtree: true });



document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('predictive-search-input');
  const productBox = document.getElementById('product-results');
  const collectionBox = document.getElementById('collection-results');
  const resultsBox = document.getElementById('predictive-search-results');

  input.addEventListener('input', function () {
    const query = this.value.trim();

    if (query.length < 2) {
      productBox.innerHTML = '';
      collectionBox.innerHTML = '';
      resultsBox.style.display = 'none';
      return;
    }

    resultsBox.style.display = 'flex';
    productBox.innerHTML = '<em>Searching products...</em>';
    collectionBox.innerHTML = '<em>Searching collections...</em>';

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products;
        const collections = data.resources.results.collections;
        const shoppages = data.resources.results.pages;

        productBox.innerHTML = products.length
          ? `<div class="ip-topsearch-heading"><strong>Produkte</strong></div><div class="ip-topsearch-products-container">` + products.map(p => `
              <a class="ip-topsearch-product" href="${p.url}" style="display: flex; align-items: center; gap: 10px; padding: 8px; border-bottom: 1px solid #eee;">
                <img class="ip-topsearch-product-img" src="${p.image}" alt="${p.title}" loading="lazy" style="width: 40px; height: auto;">
                <div class="ip-topsearch-product-content">
                  <div class="ip-topsearch-product-title" style="font-weight: bold;">${p.title}</div>
                  <div class="ip-topsearch-product-price">${p.price}</div>
                </div>
              </a>
            `).join('')+'</div>'
          : '<div class="ip-topsearch-heading"><strong>Produkte</strong></div> <div class="ip-topsearch-content"><em>No products found.</em></div>';

        collectionBox.innerHTML = collections.length
          ? `<div class="ip-topsearch-heading"><strong>Vorschläge</strong></div><div class="ip-topsearch-pages-container">` + collections.map(c => `
              <a class="ip-topsearch-collection" href="${c.url}" style="display: block; padding: 8px; border-bottom: 1px solid #eee;">
                <div style="font-weight: bold;">${c.title}</div>
              </a>
            `).join('')+'</div>'
          : '<div class="ip-topsearch-heading"><strong>Vorschläge</strong></div> <div class="ip-topsearch-content"><em>No Vorschläge found.</em></div>';
          
       var pageHtml = shoppages.length
  ? `<div class="ip-topsearch-heading ip-pages-heading"><strong>Seiten</strong></div>
     <div class="ip-topsearch-collecions-container">` +
      shoppages.map(p => `
        <a href="${p.url}" style="display: block; padding: 6px 8px; border-bottom: 1px solid #eee;">
          ${p.title}
        </a>`).join('') + '</div>'
  : `<div class="ip-topsearch-heading"><strong>Seiten</strong></div>
     <div class="ip-topsearch-content"><em>Keine Seiten gefunden.</em></div>`;

          collectionBox.innerHTML = collectionBox.innerHTML + pageHtml;

      });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('#predictive-search-form')) {
      resultsBox.style.display = 'none';
    }
  });
});



(function(){
  const container = document.querySelector('#apply_readmore .prose');
 if(container){
  const btn = document.createElement('span');
  btn.textContent = 'Read more';
  btn.classList.add('read-more-btn');

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#collection-description-footer').scrollIntoView({
      behavior: 'smooth'
    });
  });
  container.insertAdjacentElement('afterend', btn);
  
  
 }
})();

document.querySelectorAll('.ip-sidebar-categories-arrow').forEach(arrow => {
  arrow.addEventListener('click', function(e) {
    e.preventDefault();
    const parentLi = this.closest('li');
    parentLi.classList.toggle('show-childs');
  });
});




var swiper_blogs = new Swiper(".swipper-blogs", {
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      300: {
          slidesPerView: 2,
          spaceBetween: 10,
      },
      700: {
          slidesPerView: 2,
          spaceBetween: 20,
      },
      1020: {
          slidesPerView: 3,
          spaceBetween: 50,
      },
      1100: {
          slidesPerView: 4,
          spaceBetween: 30,
      },
      1200: {
          slidesPerView: 5,
          spaceBetween: 30,
      },
    }
  });



/***********************************************************/
const setupAutoScroll = () => {
  const carousel = document.querySelector('scroll-carousel.is-scrollable');
  if (!carousel || window.innerWidth < 768) return;
  let scrollInterval;
  const scrollSpeed = 4000;
  const startScrolling = () => {
    scrollInterval = setInterval(() => {
      const productList = carousel.querySelector('.product-list');
      const firstProduct = productList.querySelector('product-card');
      
      if (!firstProduct) return;
      const style = window.getComputedStyle(productList);
      const gap = parseInt(style.columnGap || style.gap || 0);
      const productWidth = firstProduct.offsetWidth + gap;
      const currentScroll = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;

      if (currentScroll >= maxScroll - 5) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollTo({
          left: currentScroll + productWidth,
          behavior: 'smooth'
        });
      }
    }, scrollSpeed);
  };
  const stopScrolling = () => clearInterval(scrollInterval);
  carousel.addEventListener('mouseenter', stopScrolling);
  carousel.addEventListener('mouseleave', startScrolling);
  carousel.addEventListener('touchstart', stopScrolling, {passive: true});
  carousel.addEventListener('touchend', startScrolling, {passive: true});
  startScrolling();
};
document.addEventListener('shopify:section:load', setupAutoScroll);
document.addEventListener('DOMContentLoaded', setupAutoScroll);


/***************************************************************************/

const initShopifyAutoScroll = () => {
  const carousels = document.querySelectorAll('scroll-carousel.is-scrollable');

  carousels.forEach((carousel) => {
    if (carousel.dataset.autoScrollInit === 'true') return;
    let scrollInterval;
    const scrollSpeed = 4000;
    const scrollNext = () => {
      const productList = carousel.querySelector('.product-list');
      const firstProduct = productList?.querySelector('product-card');
      if (!firstProduct) return;
      const style = window.getComputedStyle(productList);
      const gap = parseInt(style.columnGap || style.gap || 0);
      const productWidth = firstProduct.offsetWidth + gap;
      const currentScroll = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      if (currentScroll >= maxScroll - 10) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        carousel.scrollTo({
          left: currentScroll + productWidth,
          behavior: 'smooth'
        });
      }
    };
    const start = () => {
      stop();
      scrollInterval = setInterval(scrollNext, scrollSpeed);
    };
    const stop = () => clearInterval(scrollInterval);
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('touchstart', stop, { passive: true });
    carousel.addEventListener('touchend', start, { passive: true });
    start();
    carousel.dataset.autoScrollInit = 'true';
  });
};
document.addEventListener('DOMContentLoaded', initShopifyAutoScroll);
document.addEventListener('shopify:section:load', initShopifyAutoScroll);
const recommendationObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      initShopifyAutoScroll();
    }
  });
});
const recContainer = document.querySelector('product-recommendations');
if (recContainer) {
  recommendationObserver.observe(recContainer, { childList: true, subtree: true });
}



/***************************************************************************************************/
document.addEventListener('DOMContentLoaded', function () {
  function fixCollectionSliderWidths(swiperEl) {
    var swiper = swiperEl.swiper;
    if (!swiper) return;
    function apply() {
      var size = swiper.slidesSizesGrid && swiper.slidesSizesGrid[0];
      if (!size) return;
      swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
        slide.style.setProperty('width', size + 'px', 'important');
        slide.style.setProperty('max-width', size + 'px', 'important');
        slide.style.setProperty('min-width', '0', 'important');
      });
    }
    apply();
    swiper.on('resize', apply);
    swiper.on('breakpoint', apply);
  }

  function init() {
    document.querySelectorAll('.collection--slider').forEach(fixCollectionSliderWidths);
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var el = document.querySelector('.collection--slider');
    if (el && el.swiper) {
      init();
      clearInterval(timer);
    } else if (tries > 20) {
      clearInterval(timer);
    }
  }, 250);
});


/***********************************************************************************************/

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".IP-Detailpunkte").forEach(function (container) {
        const ul = container.querySelector("ul");

        if (ul) {
            const items = ul.querySelectorAll("li");

            const allEmpty = [...items].every(li => li.textContent.trim() === "");

            if (items.length > 0 && allEmpty) {
                container.style.display = "none";
            }
        }
    });
});